import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  constructor() {}

  setTenant(tenant: string): void {
    localStorage.setItem('urlTenant', tenant);
  }

  getTenant(): string | null {
    return localStorage.getItem('urlTenant');
  }

  clearTenant(): void {
    localStorage.removeItem('urlTenant');
  }
}
